import {
  ICreateNcm,
  INcm,
  INcmById,
  INcmParams,
  IUpdateNcm,
} from "@/@types/ncm";
import { apiSlice } from "./http";
import { Paginated } from "@/@types/paginated";
import { ISelectOptions } from "@/@types/select";
import { Tags } from "@/enum/tags";

export const ncmService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNcm: builder.query<Paginated<INcm>, INcmParams>({
      query: ({ meta, state, search, ncm, is_active, orderBy }) => {
        const params = new URLSearchParams({
          orderBy,
          page: meta.page.toString(),
          perPage: meta.perPage.toString(),
        });

        if (state) params.append('state', state);
        if (search) params.append('search', search);
        if (ncm) params.append('ncm', ncm);
        if (is_active) params.append('is_active', is_active);

        return {
          url: `/ncm/ncm-all?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.NCM],
    }),
    getNcmOptions: builder.query<ISelectOptions, void>({
      query: () => {
        return {
          url: `/ncm/options`,
          method: "GET",
        };
      },
      providesTags: [Tags.OPTIONS_NCM],
    }),
    toggleNcm: builder.mutation<void, number>({
      query: (id) => ({
        url: `/ncm/ncm-toggle?id=${id}`,
        method: "PATCH",
      }),
      invalidatesTags: [Tags.NCM],
    }),
    updateNcm: builder.mutation<void, { id: number; body: IUpdateNcm }>({
      query: ({ id, body }) => ({
        url: `/ncm/ncm-update?id=${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [Tags.NCM],
    }),
    getNcmById: builder.query<INcmById, number>({
      query: (id) => ({
        url: `/ncm/ncm-id?id=${id}`,
        method: "GET",
      }),
      providesTags: [Tags.NCM],
    }),
    createNcm: builder.mutation<void, ICreateNcm>({
      query: (body) => ({
        url: `/ncm/ncm-create`,
        method: "POST",
        body,
      }),
      invalidatesTags: [Tags.NCM],
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetNcmQuery,
  useGetNcmOptionsQuery,
  useToggleNcmMutation,
  useCreateNcmMutation,
  useGetNcmByIdQuery,
  useUpdateNcmMutation,
} = ncmService;
